import React, { FC } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { AvatarGroup } from '@material-ui/lab';

import { MinimalUserProfileFragment } from 'api';

import UserAvatar from './UserAvatar';

interface Props {
  users: MinimalUserProfileFragment[];
  size?: number;
}

const useStyles = (size: number) =>
  makeStyles(theme => ({
    avatar: {
      marginLeft: theme.spacing(-1),
      border: `2px ${theme.palette.common.white} solid`,
    },
    stack: {
      width: size,
      height: size,
    },
  }));

const UserAvatarGroup: FC<Props> = ({ size, users }) => {
  const classes = useStyles(size)();

  if (!users?.length) {
    return null;
  }

  return (
    <AvatarGroup max={15} classes={{ avatar: classes.stack }}>
      {users.map(user => (
        <UserAvatar size={size} className={classes.avatar} key={user.id} user={user} />
      ))}
    </AvatarGroup>
  );
};

UserAvatarGroup.defaultProps = {
  size: 40,
};

export default UserAvatarGroup;
